import script from "./SealConsentPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./SealConsentPop.vue?vue&type=script&setup=true&lang=ts"

import "./SealConsentPop.vue?vue&type=style&index=0&id=145059d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-145059d0"]])

export default __exports__